import '~/assets/scss/events-article.scss'


import Navigation from '~/js/modules/navigation';

import getSwiperSlider from '~/js/modules/slider';

window.addEventListener('DOMContentLoaded', () => {

  let sliderElems = document.querySelectorAll('.js-slider');
  let navMenu = document.querySelector('.js-nav-menu');

  let swipers = [{}, {}];
  const swiperParams = {
    slidesPerView: `auto`,
    loop: false,
    autoplay: false,
    navigation: {
      nextEl: `.news .slider-arrows__arrow--next`,
      prevEl: `.news .slider-arrows__arrow--prev`,
      disabledClass: `disabled`,
    },
    pagination: false,
  };

  if (window.innerWidth < 1024) {
    if (sliderElems) {
      sliderElems.forEach((elem, i) => {
        swipers[i] = getSwiperSlider(elem, swiperParams);
      });
    }
  }

  if (navMenu) {
    new Navigation(navMenu);
  }

  window.addEventListener(`resize`, () => {
    if (window.innerWidth >= 1024) {
      swipers.forEach((swiper) => {
        if (swiper.initialized) {
          swiper.destroy();
        }
      });
    } else {
      swipers.forEach((swiper, i) => {
        if (!swiper.initialized) {
          swipers[i] = getSwiperSlider(sliderElems[i], swiperParams);
        }
      });
    }
  });



});